import AsyncStorage from '@react-native-async-storage/async-storage';

const TOKEN_KEY = 'jwt_token';
const ROLE_KEY = 'auth_role';
const USERNAME_KEY = 'auth_username';
const MUST_CHANGE_KEY = 'auth_must_change_password';

export interface StoredSession {
  token: string | null;
  username: string | null;
  role: string | null;
  mustChangePassword: boolean;
}

export const authStorage = {
  async save(session: StoredSession): Promise<void> {
    const entries: [string, string][] = [];
    if (session.token) entries.push([TOKEN_KEY, session.token]);
    if (session.username) entries.push([USERNAME_KEY, session.username]);
    if (session.role) entries.push([ROLE_KEY, session.role]);
    entries.push([MUST_CHANGE_KEY, session.mustChangePassword ? '1' : '0']);
    await AsyncStorage.multiSet(entries);
  },

  async load(): Promise<StoredSession> {
    const values = await AsyncStorage.multiGet([TOKEN_KEY, USERNAME_KEY, ROLE_KEY, MUST_CHANGE_KEY]);
    const map = Object.fromEntries(values);
    return {
      token: map[TOKEN_KEY] ?? null,
      username: map[USERNAME_KEY] ?? null,
      role: map[ROLE_KEY] ?? null,
      mustChangePassword: map[MUST_CHANGE_KEY] === '1',
    };
  },

  getToken: () => AsyncStorage.getItem(TOKEN_KEY),

  async clear(): Promise<void> {
    await AsyncStorage.multiRemove([TOKEN_KEY, USERNAME_KEY, ROLE_KEY, MUST_CHANGE_KEY]);
  },
};
